// cw-quiz.js — calcule le score des blocs .cw-quiz dans les articles (Shopify-safe)
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    // Délégation globale : un seul écouteur pour toutes les pages
    document.body.addEventListener('click', function (e) {
      const btn = e.target.closest('.cw-quiz-submit');
      if (!btn) return;

      const quiz = btn.closest('.cw-quiz');
      if (!quiz) return;

      const questions = Array.from(quiz.querySelectorAll('.cw-q'));
      let correct = 0, empty = 0;

      questions.forEach(function (q, idx) {
        q.classList.remove('is-wrong', 'is-correct');
        const name = 'q' + (idx + 1);
        const picked = quiz.querySelector('input[name="' + name + '"]:checked');
        if (!picked) {
          empty++;
          q.classList.add('is-wrong');
          return;
        }
        const ok = (q.getAttribute('data-correct') || '').trim().toUpperCase();
        if (picked.value.toUpperCase() === ok) {
          correct++;
          q.classList.add('is-correct');
        } else {
          q.classList.add('is-wrong');
        }
      });

      const res = quiz.querySelector('.cw-quiz-result');
      if (res) {
        res.hidden = false;
        const total = questions.length;
        res.innerHTML =
          '<strong>Résultat :</strong> ' + correct + '/' + total +
          (empty ? ' · ' + empty + ' sans réponse' : '') +
          '<div style="margin-top:6px;font-size:14px;">' +
          (correct === total ? 'Perfect ! 🏆'
            : (correct >= Math.ceil(total * 0.7) ? 'Solide ! 💪'
              : 'Revois le trailer et retente 😄')) +
          '</div>';
        if (typeof res.scrollIntoView === 'function') {
          res.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  });
})();
